import {useMutation, useQuery} from '@tanstack/react-query';

import {RQ_ADD_OFFERS, RQ_DELETE_OFFERS, RQ_GET_OFFERS, RQ_GET_OFFERS_BY_STATUS, RQ_UPDATE_OFFERS} from './constants';
import {rqCreateRequest} from './rqHttpUtils';

export const RqGetOffers= token => {
  return useQuery({
    queryKey: ['rq_get_all_offers', token],
    queryFn: async () => {
      if (!token) {throw new Error('Token is required');}
      const response = await rqCreateRequest(RQ_GET_OFFERS, null, token, null);
      return response || [];
    },
    enabled: Boolean(token),
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const RqGetActiveOffers =()  => {
  return useQuery({
    queryKey: ['rq_get_active_offers' ],
    queryFn: async () => {
      const response = await rqCreateRequest(RQ_GET_OFFERS_BY_STATUS, null, null);
      return response || [];
    },
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const RqAddOffers = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_register_offers'],
    mutationFn: async ({token, formData}) => {
      return rqCreateRequest(
        RQ_ADD_OFFERS,
        formData,
        token,
        null,
      );
    },
    ...options,
  });
};

export const RqUpdateOffers= (options = {}) => {
  return useMutation({
    mutationKey: ['rq_update_offers'],
    mutationFn: async ({token, formData, id}) => {
      const url = RQ_UPDATE_OFFERS.url.replace('<%= id %>', id);
      try {
        const response = await rqCreateRequest(
          {...RQ_UPDATE_OFFERS, url},
          formData,
          token,
          null,
        );

        return response;
      } catch (error) {
        console.error('Error updating offers:', error);
        throw error;
      }
    },
    ...options,
  });
};

export const RQDeleteOfferAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_delete_offers'],
    mutationFn: async ({token, id}) => {
      if (!token) {throw new Error('Token is required');}
      const url = RQ_DELETE_OFFERS.url.replace('<%= id %>', id);
      try {
        const response = await rqCreateRequest(
          {...RQ_DELETE_OFFERS, url},
          null, 
          token,
          null, 
          null, 
        );

        return response;
      } catch (error) {
        console.error('Error deleting offer:', error);
        throw error;
      }
    },
    ...options,
  });
};
